import { ReactNode } from 'react';
// hooks
import useAuth from '@/hooks/useAuth';
// components
import LoadingScreen from '@/components/LoadingScreen';
import DefaultRedirect from '@/routes/DefaultRedirect';

// ----------------------------------------------------------------------

type GuestGuardProps = {
  children: ReactNode;
};

export default function GuestGuard({ children }: GuestGuardProps) {
  const { isAuthenticated, isInitialized } = useAuth();

  if (!isInitialized) {
    return <LoadingScreen />;
  }

  if (isAuthenticated) {
    return <DefaultRedirect />;
  }

  return <>{children}</>;
}
